import React from 'react';
import Card from "@mui/material/Card"
import CardContent from "@mui/material/CardContent"
import './PlanosClientesSection.css'

export function PlanosClientesSection() {
    return (
        <section className="plans-section-client">
            <div className="section-container-client">
                <h2 className="section-title-client">Planos e Precos</h2>
                <p className="plans-subtitle-client">
                    Escolha o plano ideal para o porte do seu pet. Todos incluem 4 banhos.
                </p>

                <div className="plans-grid-client">
                    {/* Pequeno */}
                    <Card className="plan-card-client">
                        <CardContent className="plan-card-content-client">
                            <div className="plan-badge-client">
                                <span className="plan-badge-default-client">Pequeno (P)</span>
                            </div>
                            <div className="plan-price-wrapper-client">
                                <div className="plan-price-client">R$ 180</div>
                                <p className="plan-price-note-client">4 banhos inclusos</p>
                            </div>
                            <button type="button" className="btn-plan-client">Escolher Plano</button>
                        </CardContent>
                    </Card>

                    {/* Medio */}
                    <Card className="plan-card-client plan-card-highlighted-client">
                        <CardContent className="plan-card-content-client">
                            <div className="plan-badge-client">
                                <span className="plan-badge-featured-client">Medio (M)</span>
                            </div>
                            <div className="plan-price-wrapper-client">
                                <div className="plan-price-client">R$ 270</div>
                                <p className="plan-price-note-client">4 banhos inclusos</p>
                            </div>
                            <button type="button" className="btn-plan-client">Escolher Plano</button>
                        </CardContent>
                    </Card>

                    {/* Grande */}
                    <Card className="plan-card-client">
                        <CardContent className="plan-card-content-client">
                            <div className="plan-badge-client">
                                <span className="plan-badge-default-client">Grande (G)</span>
                            </div>
                            <div className="plan-price-wrapper-client">
                                <div className="plan-price-client">R$ 360</div>
                                <p className="plan-price-note-client">4 banhos inclusos</p>
                            </div>
                            <button type="button" className="btn-plan-client">Escolher Plano</button>
                        </CardContent>
                    </Card>

                    {/* Extra */}
                    <Card className="plan-card-client">
                        <CardContent className="plan-card-content-client">
                            <div className="plan-badge-client">
                                <span className="plan-badge-default-client">Extra (GG)</span>
                            </div>
                            <div className="plan-price-wrapper-client">
                                <div className="plan-price-client">R$ 450</div>
                                <p className="plan-price-note-client">4 banhos inclusos</p>
                            </div>
                            <button type="button" className="btn-plan-client">Escolher Plano</button>
                        </CardContent>
                    </Card>
                </div>
            </div>
        </section>
    )
}